import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@/components/ui/card'
import { CodeBlock } from '../CodeBlock'
import { useTranslation } from '@/hooks/useTranslation'

export const VueJsSection = () => {
	const { t } = useTranslation()
	
	return (
		<section id="vuejs" className="mb-16">
			<h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">
				{t('docs.vuejs.title')}
			</h2>
			<Card className="shadow-sm dark:bg-gray-800/50">
				<CardHeader>
					<CardTitle>{t('docs.vuejs.vue3.title')}</CardTitle>
				</CardHeader>
				<CardContent>
					<p className="mb-4 text-gray-700 dark:text-gray-300">
						{t('docs.vuejs.vue3.instruction.prefix')}{' '}
						<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs">
							index.html
						</code>{' '}
						{t('docs.vuejs.vue3.instruction.suffix')}
					</p>
					<CodeBlock
						language="html"
						copyLabel={t('docs.vuejs.vue3.copyLabel')}
						copyMessage={t('docs.vuejs.vue3.copyMessage')}
						code={`<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>My Vue App</title>
  </head>
  <body>
    <div id="app"></div>
    
    <!-- Feedbask Widget -->
    <script
      defer
      src="https://cdn.feedbask.com/widget.js"
      data-client-key="YOUR_WIDGET_ID"
      data-language="en"
      id="feedbask-widget-script"
    ></script>
    
    <script type="module" src="/src/main.ts"></script>
  </body>
</html>`}
					/>
				</CardContent>
			</Card>

			<Card className="mt-6 shadow-sm dark:bg-gray-800/50">
				<CardHeader>
					<CardTitle>{t('docs.vuejs.nuxt.title')}</CardTitle>
				</CardHeader>
				<CardContent>
					<p className="mb-4 text-gray-700 dark:text-gray-300">
						{t('docs.vuejs.nuxt.instruction.prefix')}{' '}
						<code className="bg-gray-200 dark:bg-gray-700 px-1 py-0.5 rounded text-xs">
							nuxt.config.ts
						</code>
						{t('docs.vuejs.nuxt.instruction.suffix')}
					</p>
					<CodeBlock
						language="typescript"
						copyLabel={t('docs.vuejs.nuxt.copyLabel')}
						copyMessage={t('docs.vuejs.nuxt.copyMessage')}
						code={`export default defineNuxtConfig({
  app: {
    head: {
      script: [
        {
          defer: true,
          src: 'https://cdn.feedbask.com/widget.js',
          'data-client-key': 'YOUR_WIDGET_ID',
          'data-language': 'en',
          id: 'feedbask-widget-script'
        }
      ]
    }
  }
})`}
					/>
				</CardContent>
			</Card>
		</section>
	)
}